<div class="flex flex-row justify-between items-start gap-8 mt-1 mb-1">
  <rfc-title-widget [titleWidget]="defineTitleAndDescriptionWidgetObj('manage_plate')"
    class="flex-1"></rfc-title-widget>

  <mat-icon class="cursor-pointer hover:opacity-70 transition-opacity" *ngIf="!!dialogRef.id && closable"
    (click)="onClose()">close</mat-icon>
</div>

<div class="flex flex-col md:flex-row justify-around items-center gap-4 mt-1 mb-1">
  <form [formGroup]="form" class="w-full md:w-[35%]">

    <ng-container *ngIf="listPlates.length === 1; else autoCompletePlate">
      <mat-form-field class="w-full">
        <input matInput disabled formControlName="plate">
      </mat-form-field>
    </ng-container>

    <ng-template #autoCompletePlate>
      <div ald-summary-auto-complete [summary]="summary" [isInWebForm]="false" class="w-full block"></div>
    </ng-template>

  </form>
</div>

<div class="flex flex-col-reverse md:flex-row justify-center items-center gap-8 mt-1 mb-1">
  <button mat-raised-button (click)="onSubmit()" [disabled]="form.invalid"
    class="ald-mat-button primary w-full md:w-auto px-10">
    {{ "confirm" | i18n }}
  </button>
</div>